const SubscriptionPlan = {
  checkoutSubscription: {
    url: "/subscription/checkout",
    method: "POST",
  },
  createSubscription: {
    url: "/create-subscription",
    method: "POST",
  },
  subscriptionDetails: {
    url: "/user-subscription-detail",
    method: "GET",
  },
  getSubscriptionOverview: {
    url: "/user-subscription",
    method: "GET",
  },
};
export default SubscriptionPlan;
